(function() {

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '{{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal   = decimal   == null ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts   = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents   = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }

    var match = formatString.match(placeholderRegex);
    var value = '';
    if (match) {
      switch (match[1]) {
        case 'amount':                              value = formatWithDelimiters(cents, 2); break;
        case 'amount_no_decimals':                  value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator':         value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
        default:                                    value = formatWithDelimiters(cents, 2); break;
      }
    }
    return formatString.replace(placeholderRegex, value);
  }

  document.addEventListener('DOMContentLoaded', function() {
    var jsonEl = document.querySelector('[data-product-json]');
    var section = document.querySelector('[data-section-type="product"]');
    if (!jsonEl || !section) return;

    // Inject gift-certificate only styles
    var gcStyle = document.createElement('style');
    gcStyle.textContent = [
      /* No fade on desktop Flickity */
      '.product__grid--slides .flickity-slider > * { transition: none !important; }',
      /* Square image container on mobile */
      '@media (max-width: 767px) {',
      '  [data-section-type="product"] [data-product-slideshow] { aspect-ratio: 1 / 1; overflow: hidden; }',
      '  [data-section-type="product"] [data-product-slideshow] .product__media { display: none !important; width: 100%; height: 100%; }',
      '  [data-section-type="product"] [data-product-slideshow] .product__media.sx-active { display: flex !important; align-items: center; justify-content: center; }',
      '  [data-section-type="product"] [data-product-slideshow] .product__media > div,',
      '  [data-section-type="product"] [data-product-slideshow] .product-image-wrapper { width: 100%; height: 100%; }',
      '  [data-section-type="product"] [data-product-slideshow] .product__media img { width: 100%; height: 100%; object-fit: cover; object-position: center; }',
      '}'
    ].join('\n');
    document.head.appendChild(gcStyle);

    var productData;
    try {
      productData = JSON.parse(jsonEl.textContent || jsonEl.innerHTML);
    } catch(e) {
      return;
    }

    if (!productData || !productData.variants || !productData.variants.length) return;

    var moneyFormat = (window.theme && window.theme.moneyFormat) || '{{amount}}';

    function getSelectedOptions() {
      var result = [];
      section.querySelectorAll('[data-option-position]').forEach(function(wrap) {
        var pos = parseInt(wrap.getAttribute('data-option-position'), 10) - 1;
        var checked = wrap.querySelector('input[name^="options["]:checked');
        if (checked) result[pos] = checked.value;
      });
      return result;
    }

    function findVariant(opts) {
      return productData.variants.find(function(v) {
        return Array.isArray(v.options) && opts.every(function(val, i) {
          return v.options[i] === val;
        });
      }) || null;
    }

    function selectImage(featuredId) {
      var slideshow = section.querySelector('[data-product-slideshow]');
      if (!slideshow) return;

      if (slideshow.classList.contains('flickity-enabled')) {
        // Desktop: Flickity is running — use theme's native event
        slideshow.dispatchEvent(new CustomEvent('theme:image:change', { detail: { id: featuredId } }));
      } else {
        // Mobile: no Flickity — show/hide slides directly
        slideshow.querySelectorAll('[data-media-slide]').forEach(function(slide) {
          slide.classList.toggle('sx-active', slide.getAttribute('data-media-id') === featuredId);
        });
      }
    }

    function applyVariant(variant) {
      if (!variant) return;

      section.querySelectorAll('input[name="id"]').forEach(function(el) {
        el.value = variant.id;
      });

      var priceEl = section.querySelector('[data-product-price]');
      if (priceEl) priceEl.innerHTML = formatMoney(variant.price, moneyFormat);

      var compareEl = section.querySelector('[data-compare-price]');
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = formatMoney(variant.compare_at_price, moneyFormat);
        } else {
          compareEl.innerHTML = '';
        }
      }

      var featuredId = variant.featured_media_id ? String(variant.featured_media_id) : null;
      if (featuredId) selectImage(featuredId);
    }

    section.addEventListener('change', function(e) {
      if (!e.target.name || e.target.name.indexOf('options[') !== 0) return;
      applyVariant(findVariant(getSelectedOptions()));
    });

    setTimeout(function() {
      applyVariant(findVariant(getSelectedOptions()));
    }, 100);
  });

})();
